const state = {
  averages: {
    gas: [
      { label: 'Low Usage', value: 7500 },
      { label: 'Medium Usage', value: 11500 },
      { label: 'High Usage', value: 17000 }
    ],
    electricity01: [
      { label: 'Low Usage', value: 1800 },
      { label: 'Medium Usage', value: 2700 },
      { label: 'High Usage', value: 4100 }
    ],
    electricity02: [
      { label: 'Low Usage', value: 2200 },
      { label: 'Medium Usage', value: 3900 },
      { label: 'High Usage', value: 6700 }
    ],
    calculation: [
      { label: 'Low Usage', electricity02: 2200, electricity01: 1800, gas: 7500, description: 'Typically, a flat or small home with 1 to 2 occupants.' },
      { label: 'Medium Usage', electricity02: 3900, electricity01: 2700, gas: 11500, description: 'Typically, an average 2-3-bedroom home with 2 to 3 occupants.' },
      { label: 'High Usage', electricity02: 6700, electricity01: 4100, gas: 17000, description: 'Typically, an average 4 + bedroom home with 4 or more occupants.' }
    ]
  }
};

const getters = {
  averages: (state, getters, rootState, rootGetters) => {
    const quoteType = rootGetters['quote/quoteType'];
    const is02Meter = rootGetters['quote/is02Meter'];

    if (quoteType == 'gasToGas') {
      return state.averages.gas;
    }

    if (is02Meter) {
      return state.averages.electricity02;
    }

    return state.averages.electricity01;
  }
};

const actions = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
